import { useMemo } from 'react';
import data, { WorkData } from '../data';
import { nameToId } from '../utils/imageUtils';

export function useWorkData(workid?: string) {
  return useMemo(() => {
    if (!workid) return { work: null, prev: null, next: null };

    let work: WorkData | null = null;
    let prev: WorkData | null = null;
    let next: WorkData | null = null;
    
    for (var i in data.works) {
      let num = parseInt(i, 10);
      if (nameToId(data.works[num].name) === workid) {
        prev = data.works[num - 1] || null;
        work = data.works[num];
        next = data.works[num + 1] || null;
        break;
      }
    }
    
    return { work, prev, next };
  }, [workid]);
}

export function useFilteredWorks(category?: string) {
  return useMemo(() => {
    if (!category) return data.works;
    
    return data.works.filter((work: WorkData) => work.category === category);
  }, [category]);
}